import { AbstractControl, ValidationErrors } from "@angular/forms";

export class UrlValidator {

  // Form validation determines validity of URL
  static validatorFn(control: AbstractControl): ValidationErrors | null {
    const url: string = control.value as string;
    return UrlValidator.isValid(url) ? null : { invalidUrl: true }
  }

  static isValid(url: string): boolean {
    if (!url) return false;
    let parsed: URL = null;
    try { parsed = new URL(url); } catch (_err) { /* no-op */ }
    return !!parsed?.host;
  }
}